export const moderatorClassRoomHeaders = [
  { text: "Classroom Name ", align: "start", value: "name" },
  { text: "Start Date", value: "startDate", align: "center" },
  { text: "Course Name", value: "courseId", align: "center" },
  { text: "Classes", value: "classes", align: "center" },
  { text: "Progress", value: "progress", align: "center" },
  { text: "Students", value: "students", align: "center" },
  { text: "Actions", value: "actions", align: "center", sortable: false },
];

export const studentHeaders = [
  { text: "First Name", align: "start", sortable: false, value: "firstName" },
  { text: "Last Name", value: "lastName" },
  { text: "Mobile No", value: "mobileNo" },
  { text: "Email ID", value: "email" },
  { text: "Status", value: "status" },
  { text: "School Name", value: "schoolName" },
  { text: "Grade", value: "grade" },
  { text: "Actions", value: "actions", align: "center", sortable: false },
];

export const moderatorAssignmentHeaders = [
  { text: "First Name", align: "start", sortable: false, value: "firstName" },
  { text: "Last Name", value: "lastName" },
  { text: "Mobile No", value: "mobileNo", align: "center" },
  { text: "Email ID", value: "email", align: "center" },
  { text: "Status", value: "status", align: "center" },
];

export const studentHeadersForEnroll = [
  { text: "First Name", align: "start", sortable: false, value: "firstName" },
  { text: "Last Name", value: "lastName" },
  { text: "Mobile No", value: "mobileNo" },
  { text: "Email ID", value: "email" },
  { text: "Status", value: "status" },
  { text: "Institute Name", value: "schoolName" },
  { text: "Grade", value: "grade" },
];

export const teacherAssignmentHeaders = [
  { text: "First Name", align: "start", sortable: false, value: "firstName" },
  { text: "Last Name", value: "lastName" },
  { text: "Mobile No", value: "mobileNo", align: "center" },
  { text: "Email ID", value: "emailId", align: "center" },
  { text: "Status", value: "status", align: "center" },
];

export const classRoomHeaders = [
  { text: "Classroom Name", align: "start", value: "name", width: "15%" },
  { text: "StartDate", value: "startDate" },
  { text: "Teacher", value: "teacherName" },
  { text: "Moderator", value: "moderatorName" },
  { text: "CourseName", value: "courseId", width: "20%" },
  { text: "Model", value: "model", align: "center" },
  { text: "Status", value: "status", align: "center" },
  { text: "Actions", value: "actions", sortable: false },
];

export const assignmentHeaders = [
  { text: "", value: "data-table-expand" },
  { text: "Assignment No", align: "start", sortable: false, value: "assignmentNumber" },
  { text: "Name", value: "title", sortable: false },
  { text: "Actions", align: "center", value: "actions", sortable: false },
];

export const assignmentSubmissionHeaders = [
  { text: "Submitted By", value: "studentId" },
  { text: "Status", align: "center", sortable: false, value: "status" },
  { text: "Date", align: "center", value: "date" },
  { text: "Coins", value: "earnedCoins", align: "center" },
  { text: "Actions", align: "center", value: "actions", sortable: false },
];

export const quizAssignmentSubmissionHeaders = [
  { text: "Submitted By", value: "studentId" },
  { text: "Complete(%)", align: "center", value: "completed" },
  { text: "Question", value: "questions" },
  { text: "Date", align: "center", value: "date" },
  { text: "Actions", align: "center", value: "actions", sortable: false },
];

export const coinHistoryHeaders = [
  { text: "Course", value: "courseName", align: "start", width: "10%" },
  { text: "Chapter", align: "center", value: "chapterName", width: "10%" },
  { text: "Lesson", align: "center", value: "lessonName", width: "10%" },
  { text: "Competition", align: "center", value: "compName", width: "10%" },
  { text: "Quiz", align: "center", value: "quizName", width: "10%" },
  { text: "Class Name", align: "center", value: "className", width: "10%" },
  { text: "Assignment No", align: "center", value: "assignmentNumber", width: "10%" },
  { text: "Date", value: "createdDate", align: "center", width: "10%" },
  { text: "Coins", value: "coin", align: "center", width: "10%" },
];

export const competitionHeaders = [
  { align: "start", sortable: false, value: "thumbnail" },
  { text: "Name", align: "start", sortable: true, value: "name" },
  { text: "Start Date", value: "startDate", align: "center" },
  { text: "End Date", value: "endDate", align: "center" },
  { text: "Grades", value: "grades", align: "center" },
  { text: "Duration", value: "duration", align: "center" },
  { text: "CPQ", value: "coinsPerQuestion", align: "center" },
  { text: "Status", value: "status", align: "center" },
  { text: "Actions", value: "actions", align: "center", sortable: false },
];

export const contentHeaders = [
  { text: "Title", align: "start", value: "title" },
  { text: "content No.", value: "contentNo" },
  { text: "Type", value: "type", align: "center" },
  { text: "Preview", value: "preview", align: "center" },
  { text: "Actions", value: "actions", align: "center", sortable: false },
];

export const couponHeaders = [
  { text: "Coupon Code", align: "start", value: "code" },
  { text: "Discount(%)", align: "center", value: "discountPercentage" },
  { text: "Max discount", align: "center", value: "maxDiscount" },
  { text: "Expire on", value: "validTill" },
  { text: "Created on", value: "createdOn", sortable: true },
  { text: "Status", align: "center", value: "isActive" },
  { text: "Actions", sortable: false, value: "actions" },
];

export const courseAssignmentHeaders = [
  { text: "Title", align: "start", value: "title" },
  { text: "Assignment No", value: "assignmentNumber" },
  { text: "Type", value: "type", align: "center" },
  { text: "Preview", value: "preview", align: "center" },
  { text: "Coins", value: "coins", align: "center" },
  { text: "Actions", value: "actions", align: "center", sortable: false },
];

export const courseHeaders = [
  { align: "start", sortable: false, value: "thumbnail" },
  { text: "Name", align: "start", sortable: false, value: "name" },
  { text: "Status", align: "center", value: "status" },
  { text: "Price", align: "center", value: "price" },
  { text: "Classes", align: "center", value: "noOfClasses" },
  { text: "Grades", align: "center", value: "grades" },
  { text: "Actions", align: "center", value: "actions" },
];

export const courseQuizAssignmentHeaders = [
  { text: "", align: "start", value: "quizName" },
  { text: "Assignment No", value: "assignmentNumber" },
  { text: "Type", value: "type", align: "center" },
  { text: "Preview", value: "preview", align: "center" },
  { text: "Actions", value: "actions", align: "center", sortable: false },
];

export const courseTextAssignmentHeaders = [
  { text: "Title", align: "start", value: "title" },
  { text: "Assignment No", value: "assignmentNumber" },
  { text: "Type", value: "type", align: "center" },
  { text: "Preview", value: "preview", align: "center" },
  { text: "Coins", value: "coins", align: "center" },
  { text: "Actions", value: "actions", align: "center", sortable: false },
];

export const classOpsHeaders = [
  { text: "", value: "data-table-expand" },
  { text: "Date", value: "date", align: "start", sortable: false },
  { text: "Start Time", value: "startDateTime", align: "center" },
  { text: "End Time", value: "endDateTime", align: "center" },
  { text: " Actual Start Time", value: "actualStartTime", align: "center" },
  { text: "Actual End Time", value: "actualEndTime", align: "center" },
  { text: "Teacher", value: "teacherName", align: "center" },
  { text: "Status", value: "status", align: "center" },
  { text: "Actions", value: "actions", align: "center", sortable: false },
];

export const dashboardClassesHeaders = [
  { text: "Classroom Name", align: "center", value: "name" },
  { text: "Course", value: "courseId", align: "center" },
  { text: "Time", value: "time", align: "center" },
  { text: "Teacher", value: "teacherName", align: "center" },
  { text: "Status", value: "status", align: "center" },
  { text: "Actions", value: "actions", align: "center", sortable: false },
];

export const instituteHeaders = [
  { text: "Institute Name", value: "name" },
  { text: "Created On", value: "createdOn" },
  { text: "Created By", value: "createdBy" },
  { text: "Actions", value: "action", sortable: false },
];

export const loginActivityHeaders = [
  { text: "Last Login Date", value: "createdOn" },
  { text: "Active", value: "isActive" },
];

export const leaderBoardHeaders = [
  { text: "Name", value: "name" },
  { text: "Grade", align: "start", value: "grade" },
  { text: "Rank", value: "rank", align: "start" },
];
    
export const noteHeaders = [
  { text: "Title", align: "start", value: "title" },
  { text: "Note No.", value: "noteNo" },
  { text: "Type", value: "type", align: "center" },
  { text: "Preview", value: "preview", align: "center" },
  { text: "Actions", value: "actions", align: "center", sortable: false },
];

export const quizListHeaders = [
  { text: "Quiz Name", align: "start", sortable: false, value: "quizName" },
  { text: "Status", align: "center", value: "status" },
  { text: "Questions", align: "center", value: "noOfQuestions" },
  { text: "Created On", align: "center", value: "createdOn" },
  { text: "Created By", align: "center", value: "createdBy" },
  { text: "Actions", align: "center", value: "actions" },
];
    
export const resourceListHeaders = [
  { text: "Resource Name ", align: "start", value: "name" },
  { text: "Content Type", align: "center", value: "contentType" },
  { text: "Status", align: "center", value: "status" },
  { text: "CreatedOn", align: "center", value: "createdOn" },
  { text: "Created By", value: "createdBy" },
  { text: "Actions", align: "center", value: "actions", sortable: false },
];
    
export const studentClassRoomheaders = [
  { text: "Classroom Name", align: "start", value: "name" },
  { text: "Start Date", value: "startDate", align: "center" },
  { text: "Institute Name", value: "instituteId", align: "center" },
  { text: "Course Name", value: "courseId", align: "center" },
  { text: "Classes", value: "classes", align: "center" },
  { text: "Progress", value: "progress", align: "center" },
  { text: "Actions", value: "actions", align: "center", sortable: false },
];
    
export const orderHeaders = [
  { text: "", value: "data-table-expand" },
  { text: "Course Name", value: "courseName", width: "25%" },
  { text: "Price", value: "orderAmount" },
  { text: "Teacher Name", value: "teacherName", align: "center" },
  { text: "Created On", align: "center", value: "createdOn" },
  { text: "Classes", align: "center", value: "classes" },
  { text: "Status", align: "center", value: "status" },
  { text: "Actions", value: "actions", align: "center", sortable: false },
];
  
export const studentHeadersForTeacherClass = [
  { text: "First Name", align: "start", sortable: false, value: "firstName" },
  { text: "Last Name", value: "lastName" },
  { text: "Mobile No", value: "mobileNo" },
  { text: "Email ID", value: "email" },
  { text: "Status", value: "status" },
  { text: "School Name", value: "schoolName" },
  { text: "Grade", value: "grade" },
  { text: "Last Login", align: "center", value: "lastLogin" },
];
export const ukRegistrationListheaders = [
  { text: "Parent Name", align: "center", sortable: false, value: "firstName" },
  { text: "Address", align: "center", value: "street" },
  { text: "Mobile No", align: "center", value: "mobileNo" },
  { text: "Email", align: "center", value: "emailId" },
  { text: "Student Name", align: "center", value: "studentFirstName" },
  { text: "School Year", align: "center", value: "schoolYear" },
  { text: "Gender", align: "center", value: "gender" },
  { text: "Date-Time", align: "center", value: "createdOn" },
];
export const userListHeaders = [
  { text: "First Name", align: "center", sortable: false, value: "firstName" },
  { text: "Last Name", align: "center", value: "lastName" },
  { text: "Mobile No", align: "center", value: "mobileNo" },
  { text: "Email ID", align: "center", value: "email" },
  { text: "User Type", align: "center", value: "userType" },
  { text: "Status", align: "center", value: "status" },
  { text: "Created On", align: "center", value: "createdOn" },
  { text: "Last Login", align: "center", value: "lastLogin" },
  { text: "Actions", align: "center", value: "actions", sortable: false },
];
